module.exports = __webpack_public_path__ + "img/project-adaptive-2.jpg?5c66aeaa7e8574100eefaa80d7f2abd6";